import { render, staticRenderFns } from "./hesuanDetails.vue?vue&type=template&id=94ca7c6e&scoped=true&"
import script from "./hesuanDetails.vue?vue&type=script&lang=js&"
export * from "./hesuanDetails.vue?vue&type=script&lang=js&"
import style0 from "./hesuanDetails.vue?vue&type=style&index=0&id=94ca7c6e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ca7c6e",
  null
  
)

export default component.exports